import React from 'react';
import { Check, X } from 'lucide-react';

const ModuleComparisonTable = ({ modules }) => {
    return (
        <div className="overflow-x-auto">
            <table className="min-w-full bg-white rounded-lg overflow-hidden shadow">
                <thead>
                    <tr className="bg-gray-100 text-gray-700">
                        <th className="py-4 px-6 text-left">功能模組</th>
                        <th className="py-4 px-4 text-center">標準版</th>
                        <th className="py-4 px-4 text-center bg-primary-50">進階版</th>
                        <th className="py-4 px-4 text-center">專業版</th>
                    </tr>
                </thead>
                <tbody className="divide-y divide-gray-200">
                    {modules.map((module, index) => (
                        <React.Fragment key={index}>
                            <tr className={index % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
                                <td className="py-4 px-6 font-medium" colSpan="4">
                                    {module.name}
                                </td>
                            </tr>
                            {module.features.map((feature, featureIndex) => (
                                <tr key={`${index}-${featureIndex}`} className={index % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
                                    <td className="py-3 px-6 pl-12 text-sm">
                                        {feature}
                                    </td>
                                    <td className="py-3 px-4 text-center">
                                        {module.standardPlan ? (
                                            <Check size={20} className="mx-auto text-green-500" />
                                        ) : (
                                            <X size={20} className="mx-auto text-gray-300" />
                                        )}
                                    </td>
                                    <td className="py-3 px-4 text-center bg-primary-50">
                                        {module.advancedPlan ? (
                                            <Check size={20} className="mx-auto text-green-500" />
                                        ) : (
                                            <X size={20} className="mx-auto text-gray-300" />
                                        )}
                                    </td>
                                    <td className="py-3 px-4 text-center">
                                        {module.proPlan ? (
                                            <Check size={20} className="mx-auto text-green-500" />
                                        ) : (
                                            <X size={20} className="mx-auto text-gray-300" />
                                        )}
                                    </td>
                                </tr>
                            ))}
                        </React.Fragment>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default ModuleComparisonTable;